var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polyline", {
    id: "path-1",
    points: "11.3644014 9.00833102 11.3644014 4.64087648 7.11610329 11.6119837 0.0621493737 0.0364818589 7.11610329 23.1878695 11.4366501 9.00833102 11.3644014 9.00833102"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-117.979032%",
    y1: "49.9998341%",
    x2: "231.104054%",
    y2: "49.9998341%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D2031",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFE",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-4",
    points: "0.124298747 14.3554195 8.76500387 0.175880962 4.44484552 0.175880962 0.124298747 14.3554195"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-236.942234%",
    y1: "49.9994583%",
    x2: "222.58575%",
    y2: "49.9994583%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4287",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B6DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "7.05395392 0.0364818589 14.1079078 23.1878695 0.0233060152 0.0748838157 0.0233060152 0.0364818589"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-3.69384382%",
    y1: "55.8073004%",
    x2: "19.2631536%",
    y2: "55.8073004%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E4287",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#49B6DC",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-10",
    points: "0.0233060152 0.0364818589 14.1079078 0.0364818589 14.1079078 23.1878695 0.0233060152 23.1878695"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Master-Page---Header",
    transform: "translate(-351.000000, -1000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vega-logo",
    transform: "translate(351.000000, 1000.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(6.991805, 11.520587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-1",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)",
    points: "11.3644014 9.00833102 11.3644014 4.64087648 7.11610329 11.6119837 0.0621493737 0.0364818589 7.11610329 23.1878695 11.4366501 9.00833102 11.3644014 9.00833102"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(13.983609, 20.353037)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-4",
    fill: "url(#linearGradient-6)",
    mask: "url(#mask-5)",
    points: "0.124298747 14.3554195 8.76500387 0.175880962 4.44484552 0.175880962 0.124298747 14.3554195"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-7",
    fill: "#1C2030",
    points: "14.1079078 34.7084566 22.748613 20.5289181 18.4284546 20.5289181 14.1079078 34.7084566"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 11.520587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "url(#linearGradient-9)",
    mask: "url(#mask-8)",
    points: "0.0233060152 29.9304851 172.983459 29.9304851 172.983459 -11.520587 0.0233060152 -11.520587"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 11.520587)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-12"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-11",
    fill: "#1C2030",
    mask: "url(#mask-11)",
    points: "0 0.0364818589 14.1079078 23.1878695 7.05395392 0.0364818589 0 0.0364818589"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#482C50",
    points: "21.3444255 13.3865381 19.406142 13.3865381 25.7057578 19.5108822 25.7057578 13.3865381 21.3444255 13.3865381"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#783882",
    points: "19.406142 13.3865381 19.406142 19.5108822 25.7057578 19.5108822 19.406142 13.3865381"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    fill: "#1977A3",
    points: "28.5572488 6.5390852 31.6437421 9.53866205 31.6437421 6.5390852 28.5572488 6.5390852"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-17",
    fill: "#1DA1CF",
    points: "28.5572488 9.53866205 31.6437421 9.53866205 28.5572488 6.5390852 28.5572488 9.53866205"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-18",
    fill: "#E5722A",
    points: "30.7732624 -3.39122669e-15 27.6879344 -3.39122669e-15 30.7732624 2.99957684 30.7732624 -3.39122669e-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-19",
    fill: "#ED9B3A",
    points: "27.6879344 -3.39122669e-15 27.6879344 2.99957684 30.7732624 2.99957684 27.6879344 -3.39122669e-15"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-20",
    fill: "#26603A",
    points: "25.8032547 1.49959641 21.756942 1.49959641 21.756942 1.50113249 25.8032547 5.43541296 25.8032547 1.49959641"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-21",
    fill: "#3DA547",
    points: "21.756942 1.50113249 21.756942 5.43541296 25.8032547 5.43541296 21.756942 1.50113249"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-22",
    fill: "#902C2F",
    points: "25.4602678 11.3201288 25.4602678 7.95918956 22.0020436 7.95918956 25.4602678 11.3201288"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-23",
    fill: "#CF323F",
    points: "22.0020436 11.3201288 25.4602678 11.3201288 22.0020436 7.95918956 22.0020436 11.3201288"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-24",
    fill: "#1B5880",
    points: "18.8370867 4.76952303 13.5874068 4.76952303 18.8370867 9.87314309 18.8370867 4.76952303"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-25",
    fill: "#1DA1CF",
    points: "13.5874068 4.76952303 13.58663 4.76913901 13.58663 9.87314309 18.8370867 9.87314309 13.5874068 4.76952303"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVLogo);
export default __webpack_public_path__ + "static/media/v-logo.a54675b7c01a62fa65d55b3d41ef10e9.svg";
export { ForwardRef as ReactComponent };